import React from 'react';
import styles from '../../../styles/EducationHub.module.css';

interface QuickStatsProps {
	quickStats: {
		totalGuides: number;
		completedGuides: number;
		totalNews: number;
		latestUpdate: any;
	};
}

const QuickStats: React.FC<QuickStatsProps> = ({ quickStats }) => (
	<div className={styles.quickStats}>
		<div className={styles.statCard}>
			<span className={styles.statNumber} style={{ color: '#2563eb' }}>{quickStats.totalGuides}</span>
			<span className={styles.statLabel}>Available Guides</span>
		</div>
		<div className={styles.statCard}>
			<span className={styles.statNumber} style={{ color: '#16a34a' }}>{quickStats.completedGuides}</span>
			<span className={styles.statLabel}>Completed Guides</span>
		</div>
		<div className={styles.statCard}>
			<span className={styles.statNumber} style={{ color: '#d97706' }}>{quickStats.totalNews}</span>
			<span className={styles.statLabel}>Latest News</span>
		</div>
		<div className={styles.statCard}>
			<span className={styles.statNumber} style={{ color: '#7c3aed' }}>
				{quickStats.latestUpdate?.version || 'N/A'}
			</span>
			<span className={styles.statLabel}>Latest Version</span>
		</div>
	</div>
);

export default QuickStats;
